import { useErrorSnackbar } from '@lune-fe/lune-components-lib'
import { DropdownItemNew, DropdownNew, Text } from '@lune-fe/lune-ui-lib'
import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined'
import { FC, useState } from 'react'

import {
    batchUpdateLogisticsAnnotations,
    batchUpdateSheetEstimatesAnnotations,
} from 'endpoints/dapi'

const UpdateStatusDropdown: FC<{
    estimateIds: string[]
    setTableLoading: (loading: boolean) => void
    onSuccess: () => void
    sheetId: string
}> = ({ estimateIds, onSuccess, setTableLoading, sheetId }) => {
    const { enqueueSnackbar: snackbar } = useErrorSnackbar()
    const [loading, setLoading] = useState(false)

    const updateStatus = async (isShipment: boolean, updateAll: boolean) => {
        setLoading(true)
        setTableLoading(true)

        const result = updateAll
            ? await batchUpdateSheetEstimatesAnnotations({
                  sheetId,
                  isShipment,
              })
            : await batchUpdateLogisticsAnnotations({
                  ids: estimateIds,
                  isShipment,
              })

        if (result.isOk()) {
            const { affectedEstimateIds, unaffectedEstimateIds } = result.value
            if (affectedEstimateIds.length > 0) {
                snackbar(
                    `Successfully updated ${affectedEstimateIds.length} estimate${
                        affectedEstimateIds.length > 1 ? 's' : ''
                    } as ${isShipment ? 'Shipment' : 'Pre-shipment'}`,
                    { variant: 'success' },
                )
            }
            if (unaffectedEstimateIds.length > 0) {
                snackbar(
                    `${unaffectedEstimateIds.length} estimate${
                        unaffectedEstimateIds.length > 1 ? 's were' : ' was'
                    } not affected`,
                    { variant: 'warning' },
                )
            }
            onSuccess()
        } else {
            snackbar('Failed to update estimates. Please try again.', {
                variant: 'error',
                error: result.error,
            })
        }

        setLoading(false)
        setTableLoading(false)
    }

    const noSelectedId = estimateIds.length === 0

    return (
        <DropdownNew
            buttonLabel={'Edit shipment status'}
            buttonVariant={'secondary'}
            buttonSize={'sm'}
            rightIcon={
                <ArrowDropDownOutlinedIcon
                    sx={{
                        width: '20px',
                        height: '20px',
                    }}
                />
            }
        >
            <DropdownItemNew
                sx={{
                    height: '48px',
                }}
                disabled={loading}
                onClick={() => updateStatus(true, noSelectedId)}
            >
                <Text variant={'body3'}>Set {noSelectedId && 'all'} as &apos;Shipment&apos;</Text>
            </DropdownItemNew>
            <DropdownItemNew
                sx={{
                    height: '48px',
                }}
                disabled={loading}
                onClick={() => updateStatus(false, noSelectedId)}
            >
                <Text variant={'body3'}>
                    Set {noSelectedId && 'all'} as &apos;Pre-shipment&apos;
                </Text>
            </DropdownItemNew>
        </DropdownNew>
    )
}

export default UpdateStatusDropdown
